import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'conductor-conductor_driven_event-action_unknown';

/**
 * One stop shop to track all Conductor events. https://docs.google.com/document/d/1IIhPxZs1csIPhB2w948YZF34Cmg3cu3ju0HdPYYBYgg/edit?usp=sharing

actionType: click, view, dismiss
viewDisplayPage: pathname of page where it is viewed (for mobile, we’ll need to structure the page context as they don’t have path names). 
componentSurface: the requested surface enum when fetching from Conductor endpoint
renderMethod: currently either SDUI/BUILDER
campaignId: the unique id to link back to the campaign
componentId: component identifier from either SDUI or Builder within a surface area like the top banner
actionIdentifier: likely unused for view events. Will be used for click events to track specific CTAs.
productArea (pulled from campaign editor, by user entry)

 */
export function trackConductorConductorDrivenEvent(
  action_type: string,
  view_display_page2: string,
  component_surface3: string,
  render_method4: string,
  campaign_id5: string,
  component_ids6: string,
  action_identifier7: string,
  product_area8: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: {
      action_type,
      view_display_page2,
      component_surface3,
      render_method4,
      campaign_id5,
      component_ids6,
      action_identifier7,
      product_area8,
    },
  });
}
